let Dispatcher;

Dispatcher = require('flux').Dispatcher;

export default new Dispatcher();
